import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {PromotionModel} from "../models/promotion.model";
import {GameModel} from "../models/game.model";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  /*this is to read all from environments, so we don't have to import environments in components and services
  * missing isAffiliated: boolean */

  assetsPath:string;

  isRivalCasino: boolean;
  name = environment.rivalName; //sortName, what rival uses in the api url (normally we ue it for the assetsPath)  publicPromotions: PromotionModel[];
  casinoId = environment.casinoId;

  apiUrl: string;
  cdnUrl: string;

  brandName = environment.prettyName;
  contactEmail = environment.contactEmail;
  docsEmail = environment.docsEmail;
  GA_TRACKING = environment.GA_TRACKING;

  publicPromotions: PromotionModel[] = environment.publicPromotions;

  chatSystem: string;
  rivalChatGroupName: string | undefined;
  tawk_apiKey: string | undefined;
  tawk_propId: string | undefined;
  tawk_widgetId: string | undefined;

  //SEO:
  metaDesc:string = environment.metaDescription;
  logoName:string = environment.logoName;
  logoAltText: string = environment.logoAltText;

  //licence:
  licenceNo = environment.licenseNo;
  licenseInfo?: { pdb_name: string, pdb_address: string, lh_name: string, lh_address: string } = environment.license;
  withdrawalTime = environment.legalData.withdrawalTime;
  minDepositAmount = environment.legalData.minDepositAmount;
  isAffTermsNeeded: boolean = environment.legalData.affTerms;

  minAgeAtReg: number = environment.minAgeAtReg ?? 18;


  games: GameModel[] = environment.games //todo use this
  // games: GameModel[] = environment.games.filter(g=>!g.publisher.includes("FreshDeck")); //this is for testing

  // affiliatedGames: {name: string, regex: RegExp}[] = environment.affiliatedGames; //new way: using game.filter.tracker


  hasMinimalRegistration: boolean = environment.hasMinReg;


  constructor() {
    this.isRivalCasino = environment.platform === 'rival';
    this.assetsPath = environment.assetsPath ?? `assets/brands/${this.name}`

    // this.apiUrl = environment.apiUrl ?? `https://demo.casinocontroller.com/${this.name}/api-player/v3/jsonrpc` //for demo mode
    this.apiUrl = environment.apiUrl ?? `https://www.casinocontroller.com/${this.name}/api-player/v3/jsonrpc` //for prod & publishing

    this.cdnUrl = `${environment.cdnUrl}/${environment.platform}.json` // https://cdn.0x6e.com/platforms/rival.json

    this.publicPromotions = environment.publicPromotions;

    this.chatSystem = this.isRivalCasino ? 'rival' : environment.chatSystem;
    this.rivalChatGroupName = this.isRivalCasino ? environment.rivalChatGroupName : undefined;
    if (this.chatSystem === 'tawk'){
      this.tawk_apiKey = environment.tawk_apiKey;
      this.tawk_propId = environment.tawk_propertyId;
      this.tawk_widgetId = environment.tawk_widgetId;
    }

    //we dont use this anymore as we dont get games for not logged in users from rival todo delete this hackaround
    // if (this.affiliatedGames.length){
      //put affiliated games in the gamelist because rival does not send it anymore for not logged in users
      // this.games.push({
      //     "id": 2594,
      //     "name": "NodepositKings",
      //     "image": "https://cdn.casinocontroller.com/downloads/clientfiles/common/tiles/tile_512_INNodepositKings.png",
      //     "category": "InstaNet Slots",
      //     "publisher": "InstaNet",
      //     "launchUrl": null,
      //     "tag": null,
      //     "features": []
      // })
    // }

  }



}
